import { FilterOptionList, VisibleEnumSelect } from '@yeshuman/sdk'
import type { FilterDefinition, FilterOption } from '@yeshuman/sdk'
import { Ruler } from 'lucide-react'

import type { MeasurementFilters, MeasurementTypeFilter } from '../hooks/use-measurements'

export const MEASUREMENT_TYPE_OPTIONS: FilterOption[] = [
  { value: 'all', label: 'All' },
  { value: 'body_weight', label: 'Body weight' },
  { value: 'blood_pressure', label: 'Blood pressure' },
  { value: 'heart_rate', label: 'Heart rate' },
]

export function getHealthMeasurementFilterDefinitions(): FilterDefinition<MeasurementFilters, undefined>[] {
  return [
    {
      key: 'measurement_type',
      label: 'Type',
      icon: Ruler,
      displayValue: (filters) =>
        MEASUREMENT_TYPE_OPTIONS.find((o) => o.value === filters.measurement_type)?.label ?? 'All',
      isNonDefault: (filters) => Boolean(filters.measurement_type),
      reset: (filters) => ({ ...filters, measurement_type: undefined }),
      renderField: ({ filters, onChange }) => (
        <VisibleEnumSelect
          value={filters.measurement_type ?? 'all'}
          options={MEASUREMENT_TYPE_OPTIONS}
          onValueChange={(v) =>
            onChange({
              ...filters,
              measurement_type: v === 'all' ? undefined : (v as MeasurementTypeFilter),
            })
          }
        />
      ),
      renderPopover: ({ filters, onChange }) => (
        <FilterOptionList
          type="single"
          options={MEASUREMENT_TYPE_OPTIONS}
          value={filters.measurement_type ?? 'all'}
          onValueChange={(v) =>
            onChange({
              ...filters,
              measurement_type: v === 'all' ? undefined : (v as MeasurementTypeFilter),
            })
          }
        />
      ),
    },
  ]
}
